// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__KFg1f","track":"switch_track__VDl8x","thumb":"switch_thumb__uJ5KQ","label":"switch_label__YKuil"};